import { SessionDataHandling } from '../api/common/SessionDataHandling'
import moment from 'moment'
import { store } from '../redux'
import { BronsonBrand, DealerRole, DeliveryType, OriginSystem, PartnerType } from '../../models/enums'

export const isVW = () => {
  const brand = process.env.REACT_APP_WEBSITE_BRAND
  return brand === BronsonBrand.vw || brand === BronsonBrand.vw6
}

export const isVWFS = () => {
  const brand = process.env.REACT_APP_WEBSITE_BRAND
  return brand === BronsonBrand.vwfs
}

export const isCupra = () => {
  const brand = process.env.REACT_APP_WEBSITE_BRAND
  return brand === BronsonBrand.cupra
}

export const isMandatoryLogin = () => {
  return (
    process.env.REACT_APP_MANDATORY_LOGIN &&
    process.env.REACT_APP_MANDATORY_LOGIN === 'true'
  )
}
export const isVtiGiS = (storefrontData) => {
  return storefrontData?.salesChannel?.originSystem === OriginSystem.VTI_GIS
}
export const isAUDI = (storefrontData) => {
  return storefrontData?.salesChannel?.originSystem === OriginSystem.AUDI
}
export const getPartnerType = () => store.getState().storefront.data?.customerData?.partnerType
export const isStorefrontBusiness = () =>
  store.getState().storefront.data?.customerData?.storefrontPartnerType === PartnerType.BUSINESS
export const isBusiness = (storefrontData) => {
  return storefrontData?.customerData?.partnerType === PartnerType.BUSINESS
}
export const isPrivate = (storefrontData) => {
  return storefrontData?.customerData?.partnerType === PartnerType.PRIVATE
}
export const isVehicleDeliveryTypeHomeDelivery = (storefrontData) => {
  return storefrontData?.vehicleData?.delivery?.deliveryType === DeliveryType.HOME_DELIVERY
}
export const isVehicleDeliveryTypeDealerShop = (storefrontData) => {
  return storefrontData?.vehicleData?.delivery?.deliveryType === DeliveryType.DEALERSHOP
}
export const isDealerRolePickUp = (storefrontData) => {
  return storefrontData?.dealerData?.additionalDealers?.some(
    (dealer) => dealer.dealerRole === DealerRole.PICKUP
  )
}
export const hasEmployeeDiscount = () => {
  const storefrontData = store.getState().storefront.data
  return storefrontData?.vehicleData?.hasEmployeeDiscount
} 
export const getOriginSystem = (storefrontData) =>
  storefrontData?.salesChannel?.originSystem

export const notFalsy = (value) => {
  return value !== undefined && value !== null
}

export const saveSesionData = (data) => {
  const sessionData = {
    ...(data?.transactionId && { transactionId: data.transactionId }),
    ...(data?.token && { token: data.token }),
  }
  SessionDataHandling.saveSessionDataToStorage(sessionData)
}

export const shouldShowAdditionalProductsItem = (financialProduct) => {
 return financialProduct?.additionalProducts?.find(
    (product) =>
      product.isSelected === true &&
      product.qualifiers?.find((item) => item.id === 'REG1')
  )
}

export const monthsDifference = (startDate, endDate) =>
  Math.abs(moment(endDate).diff(moment(startDate), 'months'))
export const isENVKVNew = (vehicleData) =>
  ((!vehicleData?.isUsed && vehicleData?.odometer < 1000) ||
    monthsDifference(vehicleData?.initialRegistrationDate, moment.now()) < 8) &&
  !vehicleData?.model?.economics?.at(0)?.skipEnvkv

export const openTabUrl = (url) => {
  window.open(url, '_blank')
}
